export const MessageHelper = {
    CREATING: {
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de la création.`,
        LOADING: (resourceName: string) => `${resourceName} : Création en cours de soumission...`,
        SUCCESS: (resourceName: string) => `${resourceName} : Crétion réussie.`,
    },
    PASSWORD: {
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de la mise à jour du mot de passe.`,
        LOADING: (resourceName: string) => `${resourceName} : Mise à jour en cours de soumission...`,
        SUCCESS: (resourceName: string) => `${resourceName} : Mise à jour de mot de passe réussie.`,
    },

    PASSWORD_GENERATING: {
        NOT_ALLOWED: (resourceName: string) => `${resourceName} : Vous n'êtes pas autorisé(e) à réinitialiser le mot de passe.`,
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de réinitialisation du mot de passe.`,
        LOADING: (resourceName: string) => `${resourceName} : Réinitialisation du mot de passe en cours de soumission...`,
        SUCCESS: (resourceName: string) => `${resourceName} : Réinitialisation du mot de passe réussie.`,
        UKNOWN_ERROR:(resourceName: string) => `${resourceName} : Un problème technique s'est produit lors de la génération du mot de passe : (Agent id not found). Merci de le reporter à l'administrateur de l'application."`
    },

    FETCHING: {
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de la récupération.`,
        LOADING: (resourceName: string) => `${resourceName} : Récupération en cours... Merci de patienter..`,
        SUCCESS: (resourceName: string) => `${resourceName} : Récupération réussie.`,
        NOTFOUND: (resourceName: string) => `${resourceName} : Elément non trouvée.`,
    },

    EDITING: {
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de la mise à jour.`,
        LOADING: (resourceName: string) => `${resourceName} : Mise à jour en cours de chargement... merci de patienter..`,
        SUCCESS: (resourceName: string) => `${resourceName} : Mise à jour réussie.`,
    },
    RESTORING: {
        NOT_ALLOWED: (resourceName: string) => `${resourceName} : Vous n'êtes pas autorisé(e) à restaurer cette ressource.`,
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de la restauration.`,
        LOADING: (resourceName: string) => `${resourceName} : Restauration en cours... merci de patienter.`,
        SUCCESS: (resourceName: string) => `${resourceName} : Restauration réussie - Elément déplacé vers "Actifs".`,
    },

    DELETING: {
         NOT_ALLOWED: (resourceName: string) => `${resourceName} : Vous n'êtes pas autorisé(e) à supprimer cette ressource.`,
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de la suppression.`,
        LOADING: (resourceName: string) => `${resourceName} : Suppression en cours... merci de patienter.`,
        SUCCESS: (resourceName: string) => `${resourceName} : Suppression réussie.`,
    },
    LISTING: {
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors du chargement de la liste.`,
        LOADING: (resourceName: string) => `${resourceName} : Chargement en cours... Merci de patienter..`,
        SUCCESS: (resourceName: string) => `${resourceName} : Liste chargée avec succès.`,
        NOTFOUND: (resourceName: string) => `${resourceName} : Liste non trouvée.`,
    },

    ENRICHMENT: {
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors du chargement de des donnée supplémentaires.`,
    },

    TECHNICL_ERROR: (resourceName: string) => `${resourceName} : Une erreur technique s'est produite. Veuillez contacter l'administrateur de l'application..`,

    EXPORTING: {
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de l'export des données.`,
        LOADING: (resourceName: string) => `${resourceName} : Export en cours... Merci de patienter..`,
        SUCCESS: (resourceName: string) => `${resourceName} : Données exportées avec succès.`,
        NOT_AUTHORIZED : (resourceName: string) => `${resourceName} : Permission insuffisante pour exporter les données.`,
    },
    GENERATING: {
        ERROR: (resourceName: string) => `${resourceName} : Une erreur est survenue lors de la generation des données à exporter.`,
        LOADING: (resourceName: string) => `${resourceName} : Génération de fichier en cours... Merci de patienter..`,
        SUCCESS: (resourceName: string) => `${resourceName} : Données exportées avec succès.`,
        NOT_AUTHORIZED : (resourceName: string) => `${resourceName} : Permission insuffisante pour exporter les données.`,
    },
    MODAL: {
        CONFIRM: {
            TITLE: "Demande de Confirmation",
            DELETING: (resourceName: string) => `${resourceName} : Etes-vous sûr de vouloir supprimer cet élément?`,
            RESTORING: (resourceName: string) => `${resourceName} : Etes-vous sûr de vouloir restaurer cet élément?`,
            REMOVING: (resourceName: string) => `${resourceName} : Etes-vous sûr de vouloir retirer cet élément?`,
            PASSWORD: {
                GENERATING: (resourceName: string, agentName: string) => `${resourceName} : Vous êtes sur le point de régénérer le mot de passe de cet agent : ${agentName} . Cette action remplacera le mot de passe actuel et l'agent devra utiliser le nouveau mot de passe pour se connecter. Voulez-vous continuer ?`,
                RESET: (resourceName: string) => `${resourceName} : Etes-vous sûr de vouloir retirer cet élément?`,
            },
            GENERATING : {
                PDF : (resourceName: string) => `${resourceName} : Vous êtes sur le point de (re)générer un fichier PDF lié à ce domaine.\nVoulez-vous continuer ?`,
                EXCEL : (resourceName: string) => `${resourceName} : Vous êtes sur le point de générer un fichier excel. \nLes filtres et l'ordre de tri actifs seront pris en compte dans le fichier.\nVoulez-vous continuer ?`,
                DEFAULT : (resourceName: string) => `${resourceName} : Vous êtes sur le point de générer un fichier.\nVoulez-vous continuer ?`,
          
            },
            EXPORTING : {
                EXCEL : (resourceName: string) => `${resourceName} : Vous êtes sur le point d'exporter ces données sous format excel. \nLes filtres et l'ordre de tri actifs seront pris en compte dans le fichier.\nVoulez-vous continuer ?`,
                PDF : (resourceName: string) => `${resourceName} : Vous êtes sur le point de télécharger le fichier PDF lié à ce domaine.\nVoulez-vous continuer ?`,
                DEFAULT : (resourceName: string) => `${resourceName} : Vous êtes sur le point de télécharger le fichier.\nVoulez-vous continuer ?`,
            }
        }
    },
    PREPARATION: {
        FORM: (resourceName: string) => `${resourceName} : Formulaire en cours de préparation... Merci de patienter.`
    },

    BIRTHWISH: {
        NEW: (contactName: string) => `Bonjour ${contactName},

Toute l'équipe de ICAZI vous souhaite un merveilleux anniversaire !
Que cette journée soit remplie de joie, de belles surprises et de moments inoubliables.

Très chaleureusement,

L'équipe de ICAZI`
    },

    TECHNICAL : {
        MISSING_HOOK : {
            TITLE : "Hook manquant",
            MESSAGE : "Un hook obligatoire est absent. Veuillez contacter l'administrateur de l'application."
        }
    }

}
